// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_claim_management_styles" + "." + "43bb1999" + ".chunk.css";
};